import { DraggableProvidedDragHandleProps } from "@hello-pangea/dnd";
import { createContext, useContext } from "react";

import { IMessageStore } from "@/components/Playground/Messages/Message/message-store";
import { ChildMessagesStore } from "@/components/Playground/Messages/PlaceholderContainer/stores/child-messages-store";
import { PlaceholderContainerStore } from "@/components/Playground/Messages/PlaceholderContainer/stores/placeholder-container-store";
import type { VariableSet } from "@/components/Playground/types";

export type { ChildMessagesStore };

interface PlaceholderContainerContextValue {
  message: IMessageStore;
  index: number;
  readonly: boolean;
  dragHandleProps?: DraggableProvidedDragHandleProps;
  placeholderStore: PlaceholderContainerStore;
  childStore: ChildMessagesStore;
  childStoresMap: Map<string, ChildMessagesStore>;
  variableSets: VariableSet[];
  leftBraces: string;
  rightBraces: string;
}

const PlaceholderContainerContext = createContext<PlaceholderContainerContextValue | null>(null);

export const usePlaceholderContainer = () => {
  const context = useContext(PlaceholderContainerContext);
  if (!context) {
    throw new Error("usePlaceholderContainer must be used within PlaceholderContainerProvider");
  }
  return context;
};

export const PlaceholderContainerProvider = PlaceholderContainerContext.Provider;
